<template>
  <div>
    <div v-if="dcf.lignesCommande.length === 0"
         class="card card-article-any has-background-background mgb-20px">
      <app-aucun-article></app-aucun-article>
    </div>
    <div v-else>
      <div class="level mgb-20px">
        <div class="level-left">
          <div class="columns is-marginless is-paddingless is-multiline card-article">
            <div class="commandes__ligne-selecteurs">
              <b-icon class="mgl-20px"></b-icon>
              <qd-checkbox :value="selectAllLine" @input="selectAllLigneCommande">
              </qd-checkbox>
            </div>
            <selecteur-action
              class="column is-narrow"
              @handleAction="handleAction"
              :options='getActionPossible'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="selectedLigne"
            ></selecteur-action>
          </div>
        </div>
        <div class="level-right pdr-20px">
          <b-tooltip
            :label="$t('dcf.trierLignes')"
            position="is-left">
            <div class="pdr-10px">
              <qd-button
                @click="popUpTriLignes = true"
                :disabled="dcfIsCommandePartiellement">
                <b-icon
                  :class="{ 'text-access-no-permission': dcfIsCommandePartiellement }"
                  type="is-default"
                  icon="sort"/>
              </qd-button>
            </div>
          </b-tooltip>
          <b-tooltip
            :label="$t(allOpen ? 'ajoutDevis.hideLigne' : 'ajoutDevis.openLigne')"
            position="is-left">
            <button class="button" @click="toggle()">
              <b-icon
                :icon="allOpen ? 'collapse-all' : 'expand-all'"
                type="is-default">
              </b-icon>
            </button>
          </b-tooltip>
        </div>
      </div>
    </div>
    <lignes-vente ref="ligneVente"
                  :dcf="dcf"
                  :lignes-commande-to-display="getLignesCommandeToDisplay(false)"
                  :is-credit-note="isCreditNote"
                  :isAvoirLibre="isAvoirLibre"
                  :error="error"
                  :commandeAchatARapprocher="commandeAchatARapprocher"
                  :sens="sens"
                  :ordre-dernier-ajoute="ordreDernierAjoute"
                  :modulePresseActive="modulePresseActive"
                  :periodeTotalCalculTlpeAuto="periodeTotalCalculTlpeAuto"
                  :filtrerProduitParSociete="filtrerProduitParSociete"
                  :activationYield="activationYield"
                  :regimesTva="regimesTva"
                  :categoriesProduct="categoriesProduct"
                  @change="changeOrder"
                  @reloadTotalHt="calcul()"
                  @modificationLigneCommande="modificationLigneCommande"
                  @dissocierPersonnalise="dissocierPersonnalise"
                  @messagesErrors="errorsManager"
    >
    </lignes-vente>
    <div v-if="dcfIsCommandePartiellement"
         class="mgb-20px has-text-weight-bold has-text-default">
      {{ $t('ajoutDevis.partial.produitCommande') }}
    </div>
    <lignes-vente v-if="dcfIsCommandePartiellement"
                  :dcf="dcf"
                  :lignes-commande-to-display="getLignesCommandeToDisplay(true)"
                  :is-credit-note="isCreditNote"
                  :isAvoirLibre="isAvoirLibre"
                  :error="error"
                  :sens="sens"
                  :ordre-dernier-ajoute="ordreDernierAjoute"
                  :modulePresseActive="modulePresseActive"
                  :periodeTotalCalculTlpeAuto="periodeTotalCalculTlpeAuto"
                  :filtrerProduitParSociete="filtrerProduitParSociete"
                  :activationYield="activationYield"
                  :regimesTva="regimesTva"
                  :categoriesProduct="categoriesProduct"
                  @change="changeOrder"
                  @reloadTotalHt="calcul()"
                  @modificationLigneCommande="modificationLigneCommande"
                  @dissocierPersonnalise="dissocierPersonnalise"
                  @messagesErrors="errorsManager"
    >
    </lignes-vente>
    <br v-if="dcf.lignesCommande &&
        dcf.lignesCommande.length">
    <div class="columns level">
      <div class="column is-6 buttons section section-details">
      <dropdownButton
        type="is-primary"
        class="is-inline-block mgr-2"
        v-if="(!isCreditNote || isAvoirLibre)"
        :actions="actionSecondary"
        @click="ajouterLigne(typeArticle)">
          {{ $t('ajoutDevis.actions.addLine')}}
      </dropdownButton>
      <dropdownButton
        type="is-primary"
        class="is-inline-block mgr-2"
        v-if="(!isCreditNote || isAvoirLibre) && isSensVente"
        :actions="actionSecondaryAddProduct"
        @click="ajouterLigne(typeArticle)">
          {{ $t('ajoutDevis.actions.addProduct')}}
      </dropdownButton>
        <button class="button is-primary" @click="ajouterLigneRemise()"
                v-if="canAddRemise">
          {{ $t('ajoutDevis.actions.addRemise')}}
        </button>
      </div>
      <div class="commandes__total">
        <div class="commandes__total-ligne">
          <div>
            <span>
              {{ $t('ajoutDevis.informations.totalHt')}}
            </span>
            <span class="has-text-weight-semibold ellipsis">
              {{ dcf.montantHt | formatDevise }}
            </span>
          </div>
        </div>
        <div :key="tva.tauxTva" v-for="(tva) in dcf.repartitionsTva">
          <div class="commandes__total-ligne">
            <div>
              <span>
                {{ $t('ajoutDevis.informations.totalTva')}}
                ({{ tva.tauxTva }}%)
              </span>
              <span class="ellipsis" v-if="tva.totalTva !== null">
                {{ tva.totalTva | formatDevise }}
              </span>
            </div>
          </div>
        </div>
        <div class="commandes__total-ligne">
          <div>
            <span>
                {{ $t('ajoutDevis.informations.totalTva')}}
            </span>
            <span class="ellipsis">
              {{ dcf.montantTva | formatDevise }}
            </span>
          </div>
        </div>
        <div class="commandes__total-ligne">
          <div>
            <span>
              {{ $t('ajoutDevis.informations.totalTtc')}}
            </span>
            <span class="has-text-weight-semibold ellipsis">
              {{ dcf.montantTtc | formatDevise }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="affichagePopUpMajTarif"
             has-modal-card
             class="modal" width="336px">
      <app-popup-maj-prix-unitaire @updatePrixUnitaire="updatePrixUnitaire" />
    </b-modal>
    <b-modal v-model="affichagePopUpMajTva"
             has-modal-card
             class="modal" width="336px">
      <app-popup-maj-tva @updateTva="updateTva" />
    </b-modal>
    <b-modal v-model="popUpInformationRegroupement" has-modal-card class="modal"
             width="75vw" custom-class="modal-width-75vw">
      <app-information-regroupement-personnalise :lignesCommande="getSelectedLigne"/>
    </b-modal>
    <b-modal v-model="errorPopUp"
             has-modal-card
             class="modal">
      <app-popup-erreur
        :messHeader="headerError"
        :messagesPopup="messagesPopup"
      />
    </b-modal>
    <b-modal v-model="popUpChangeMultipleEtatOption"
             has-modal-card
             class="modal">
      <popUpModificationEtatSouhaite @newEtat="changeEtatSouhaiteReseauTempo"/>
    </b-modal>
    <b-modal v-model="popUplignesRemise"
             has-modal-card
             class="modal">
      <add-remise-perso-to-multi-lignes :lignesCommande="selectLinesGetter"
                                        @validationRemise="majRemiseGrouped"/>
    </b-modal>
    <b-modal v-model="popUpRemiseNetFace"
             has-modal-card
             class="modal">
      <pop-up-remise-net-face @remiseNetFace="remiseNetFace"
                              :lignes="dcf.lignesCommande.filter(l => l.selected)">
      </pop-up-remise-net-face>
    </b-modal>
    <b-modal v-model="popUpDuplicationLigne"
      class="modal"
      has-modal-card>
      <pop-up-duplication-ligne
        @makeDuplication="makeDuplication"
      />
    </b-modal>
    <b-modal v-model="popUpModifierDates"
      class="modal"
      has-modal-card>
      <popUpModificationDate :lignes="getSelectedLigne" @updateDate="updateDate"/>
    </b-modal>
    <b-modal
      v-model="popUpTriLignes"
      has-modal-card
      class="modal"
      width="500px">
      <pop-up-tri-lignes @gestionTriLignes="gestionTriLignes"/>
    </b-modal>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import dropdownButton from '@/components/general/button/dropdownButton';
import aucunArticle from '@/components/devisCommandes/editionDevisCommande/aucunArticle';
import * as devisConf from '@/configuration/devisConf';
import miseAJourPrixUnitaire from '@/services/devisCommandes/miseAJourPrixUnitaire';
import miseAJourTva from '@/services/devisCommandes/miseAJourTva';
import miseAJourDate from '@/services/devisCommandes/miseAJourDate';
import selectLinesFormRegroupementPersonalise from '@/services/devisCommandes/selectLinesFormRegroupementPersonalise';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import creationRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/creationRegroupementPersonnalise';
import suppressionRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/suppressionRegroupementPersonnalise';
import validationRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/validationCreationRegroupementPersonnalise';
import reordonnancementRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/reordonnancementRegroupementPersonnalise';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import miseAJourSousTotal from '@/services/devisCommandes/miseAJourSousTotal';
import miseAJourLigneRemise from '@/services/devisCommandes/miseAJourLigneRemise';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import miseAJourCommentaire from '@/services/devisCommandes/miseAJourCommentaire';
import modificationLigne from '@/services/devisCommandes/modificationLigneCommande';
import * as produitConf from '@/configuration/catalogue/produitConf';
import popUpMajPrixUnitaire from '@/components/devisCommandes/editionDevisCommande/popupMajPrixUnitaire';
import popUpMajTva from '@/components/devisCommandes/editionDevisCommande/popupMajTva';
import informationRegroupementPersonnalise from '@/components/devisCommandes/editionDevisCommande/informationRegroupementPersonnalise';
import validationRegroupementInformation from '@/services/devisCommandes/validationRegroupementInformation';
import maxOrderBaseGetter from '@/services/devisCommandes/maxOrderBaseGetter';
import * as types from '@/store/modules/commande-mutation-type';
import popupErreur from '@/components/general/popUpErreur';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_MASS_DELETE } from '@/configuration/general/actionsConf';
import {
  CATEGORIE_UNITAIRE,
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT_MAIRIE,
  CATEGORIE_ECRAN_NUMERIQUE,
  CATEGORIE_SALON,
  CATEGORIE_SPONSORING,
  CATEGORIE_AUTRE,
  CATEGORIE_PRESSE,
} from '@/configuration/catalogue/produitConf';
import popUpModificationEtatSouhaite from '@/components/devisCommandes/editionDevisCommande/p_modificationEtatSouhaite';
import popUpDuplicationLigne from '@/components/devisCommandes/editionDevisCommande/p_duplicationLigne';
import { AUCUN, BLOQUE, BLOQUE_COMMANDE } from '@/configuration/optionBlocage/optionBlocage';
import { addReferenceEcheancierToLigneCommande }
  from '@/services/commande/echeancierFacturation/addReferenceEcheancierToLigneCommande';
import deleteLignesEcheanciersInutiles from '@/services/commande/echeancierFacturation/deleteLignesEcheanciersInutiles';
import calculRemiseMultiProduitWithSoult from '@/services/dcf/remise/remiseMultiProduit/soultForRemiseMultiProduit';
import fusionEcheancier from '@/services/commande/echeancierFacturation/fusionEcheancier';
import popUpTriLignes from '@/components/devisCommandes/editionDevisCommande/p_triLignes';
import { getLigneAPlatWithRegroupement } from '@/services/dcf/lignesDCF/getLigneAPlat';
import addRemisePersoToMultiLignes from '@/components/devisCommandeFacture/remise/addRemisePersoToMultiLignes';
import lignesVente from '@/components/bodac/dcf/addEditDcf/lignesVente';
import { REGIE } from '@/configuration/societe/societe';
import popUpRemiseNetFace from '@/components/bodac/dcf/addEditDcf/remise/p_remiseNetFace';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { checkValidationLigneCommandeForDeleteAsync } from '@/api/logistique/demandeLogistique';
import simulationEtatObtenu from '@/services/devisCommandes/optionBlocage/simulationEtatObtenu';
import { siteHasHolding } from '@/services/general/holding';
import validationLigneCommandeDemandeLogistique from '@/services/dcf/validation/validationLigneCommandeDemandeLogistique';
import popUpModificationDate from '@/components/devisCommandes/editionDevisCommande/p_modificationDate';
import initialisationOptionBlocage
  from '@/services/devisCommandes/optionBlocage/initialisationOptionBlocage';
import updateDatesAllEcheancierAuto from '@/services/commande/echeancierFacturation/updateDatesAllEcheancierAuto';
import {
  getAffectionOfProductFace,
  updateAffection,
  getAffectionOfProductReseauLc,
  getAffectionOfProductEcranNumerique,
  getAffectionOfProductReseauNumerique,
} from '@/services/affectation/affectation';
import updateQuantiteDispo from '@/services/devisCommandes/updateQuantiteDispo';
import trierListe from '@/services/devisCommandes/trierLigneCommande';
import estDemandeManuelle from '@/services/devisCommandes/estDemandeManuelle';
import { checkIfLignesCanBeDeletedWithBesoin } from '@/services/bodac/besoin/besoinService';

const Commandes = createNamespacedHelpers('commande');
const Parametres = createNamespacedHelpers('parametres');
const Societes = createNamespacedHelpers('societe');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  props: {
    dcf: {
      type: Object,
      required: true,
      default: null,
    },
    commandeAchatARapprocher: {
      type: Array,
      required: false,
    },
    error: {
      type: Boolean,
      required: true,
      default: false,
    },
    sens: {
      type: String,
      required: false,
      default: devisConf.SENS_VENTE,
    },
    breadcrumb: {
      type: Array,
      required: true,
      default: null,
    },
    isCreditNote: {
      default: false,
      required: false,
      type: Boolean,
    },
    isAvoirLibre: {
      default: false,
      required: false,
      type: Boolean,
    },
    categoriesProduct: {
      type: Array,
      required: false,
      default: () => null,
    },
  },
  components: {
    appAucunArticle: aucunArticle,
    dropdownButton,
    appPopupMajPrixUnitaire: popUpMajPrixUnitaire,
    appPopupMajTva: popUpMajTva,
    appInformationRegroupementPersonnalise: informationRegroupementPersonnalise,
    selecteurAction,
    appPopupErreur: popupErreur,
    popUpModificationEtatSouhaite,
    addRemisePersoToMultiLignes,
    lignesVente,
    popUpRemiseNetFace,
    popUpDuplicationLigne,
    popUpModificationDate,
    popUpTriLignes,
  },
  data() {
    return {
      selectAllLine: false,
      popUpInformationRegroupement: false,
      messagesPopup: [],
      reseauNumerique: produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE,
      ecranNumerique: produitConf.CATEGORIE_ECRAN_NUMERIQUE,
      typeArticle: devisConf.NORMAL,
      typeSousTotal: devisConf.SOUS_TOTAL,
      typeCommentaire: devisConf.COMMENTAIRE,
      typeRemise: devisConf.REMISE,
      affichagePopUpMajTarif: false,
      affichagePopUpMajTva: false,
      ordreDernierAjoute: null,
      popUpChangeMultipleEtatOption: false,
      produitRegroupement: produitConf.CATEGORIE_REGROUPEMENT,
      popUplignesRemise: false,
      popUpRemiseNetFace: false,
      popUpDuplicationLigne: false,
      popUpModifierDates: false,
      popUpTriLignes: false,
      errorPopUp: false,
      headerError: null,
      actions: [
        { action: devisConf.ACTION_INFORMATION_GROUPER_PERSONNALISE, translation: 'ajoutDevis.actions.informationRegroupement' },
        { action: devisConf.ACTION_GROUPER_MAJ_PU, translation: 'ajoutDevis.actions.groupedActionMajPu' },
        { action: devisConf.ACTION_GROUPER_MAJ_TVA, translation: 'ajoutDevis.actions.groupedActionMajTva' },
        { action: devisConf.ACTION_DUPLICATION, translation: 'ajoutDevis.actions.duplication' },
        { action: ACTION_MASS_DELETE, translation: 'ajoutDevis.actions.groupedActionMasseDelete' },
        { action: devisConf.ACTION_MODIFIER_DATES, translation: 'ajoutDevis.actions.modifierDates' },
      ],
      allOpen: true,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societes.mapGetters({
      agenceActive: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...CategorieVente.mapGetters({
      categorieProduitByCode: 'categorieProduitByCode',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    periodeTotalCalculTlpeAuto() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key);
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    activationYield() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.activationYield.key);
    },
    interdireModificationBlocageCLGActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key);
    },
    regimesTva() {
      return this.parametre(PARAMETRES_KEYS.regimeTva);
    },
    priseEnCompteRemiseCompta() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key);
    },
    canAddRemise() {
      const onlyProductFromSociete = !this.dcf.lignesCommande.some((l) => {
        return l.produit && l.produit.supportCommercial
          && l.produit.supportCommercial.societeId !== (this.dcf.id
            ? this.dcf.societeId : this.societeActiveId);
      });
      return !this.isCreditNote && this.isSensVente && (!siteHasHolding()
        || (siteHasHolding() && onlyProductFromSociete)) && !this.priseEnCompteRemiseCompta;
    },
    getRemiseTvaDefaut() {
      const agenceFind = this.agenceActive.find((agence) => {
        return agence.agenceId === this.dcf.agenceId;
      });
      if (!agenceFind || !agenceFind.regimeTvaId) return null;
      const regimeFind = this.regimesTva.find((regime) => {
        return regime.id === agenceFind.regimeTvaId;
      });
      return regimeFind ? regimeFind.tauxTva : null;
    },
    dcfIsCommandePartiellement() {
      return this.dcf.etat === devisConf.ETAT_COMMANDE_PARTIELLEMENT;
    },
    isCommandeFromDevis() {
      return (this.dcf.referenceId && this.dcf.type === devisConf.TYPE_COMMANDE);
    },
    isSensVente() {
      return this.sens === devisConf.SENS_VENTE;
    },
    selectedLigne() {
      return this.dcf.lignesCommande.some((ligne) => {
        return ligne.selected === true;
      });
    },
    selectLinesGetter() {
      const lignes = selectLinesFormRegroupementPersonalise(this.dcf.lignesCommande);
      return getLigneAPlatWithRegroupement(lignes);
    },
    getSelectedLigne() {
      return this.dcf.lignesCommande.filter((ligne) => {
        return ligne.selected === true && ligne.produitId;
      });
    },
    getActionPossible() {
      const clonedActions = cloneDeep(this.actions);
      if (!(this.dcf.role !== REGIE
        || (this.dcf.type === devisConf.TYPE_COMMANDE
          && (this.dcf.etat === devisConf.ETAT_FACTURE
          || this.dcf.etat === devisConf.ETAT_FACTURE_PARTIELLEMENT)))) {
        clonedActions.push({ action: devisConf.ACTION_GROUPER_PERSONNALISE, translation: 'ajoutDevis.actions.groupedActionGroup' });
      }
      if (this.dcf.lignesCommande.find((ligne) => {
        return ligne.type === devisConf.REGROUPEMENT
          && ligne.typeProduit === produitConf.CATEGORIE_REGROUPEMENT;
      })) {
        clonedActions.push({ action: devisConf.ACTION_REMISE_PRIX_NET_FACE, translation: 'ajoutDevis.actions.remisePrixNetFace' });
      }
      if (this.isCreditNote) {
        return [{ action: ACTION_MASS_DELETE, translation: 'ajoutDevis.actions.groupedActionMasseDelete' }];
      }
      /* Possibilite de faire un remise groupée si toutes les lignes qui ne sont pas des lignes de
      regroupement personnalisé et qui ont le même produit ou qui n'ont pas de cgv */
      const lignesAVerifier = this.dcf.lignesCommande.filter(l => {
        return l.selected && l.type !== devisConf.PERSONNALISE;
      });
      if (lignesAVerifier.every(ligne => {
        return ligne.produitId === lignesAVerifier[0]?.produitId;
      }) || lignesAVerifier.every(ligne => {
        return ligne.produit?.cgvs?.length === 0;
      })) {
        clonedActions.push({ action: devisConf.ACTION_GROUPER_MAJ_REMISE, translation: 'ajoutDevis.actions.groupedActionMajRemisePerso' });
      }
      return clonedActions;
    },
    actionSecondary() {
      const actions = [];

      if (this.isSensVente) {
        actions.push(
          {
            label: this.$t('ajoutDevis.actions.addSubTotal'),
            action: () => { this.ajouterLigne(this.typeSousTotal); },
          },
          {
            label: this.$t('ajoutDevis.actions.addComment'),
            action: () => { this.ajouterLigne(this.typeCommentaire); },
          },
        );
      }

      return actions;
    },
    actionSecondaryAddProduct() {
      const actions = [
        {
          categorie: CATEGORIE_UNITAIRE,
          label: this.$t('ajoutDevis.actions.addFace'),
          action: () => { this.ajoutProduitFace(); },
          order: 1,
        },
        {
          categorie: CATEGORIE_REGROUPEMENT_LC,
          label: this.$t('ajoutDevis.reseauLc'),
          action: () => { this.ajoutProduitReseauLc(); },
          order: 3,
        },
        {
          categorie: CATEGORIE_REGROUPEMENT_MAIRIE,
          label: this.$t('ajoutDevis.reseauMairie'),
          action: () => { this.ajoutProduitReseauMairie(); },
          order: 4,
        },
        {
          categorie: CATEGORIE_ECRAN_NUMERIQUE,
          label: this.$t('ajoutDevis.faceNum'),
          action: () => { this.ajoutProduit(this.ecranNumerique); },
          order: 5,
        },
        {
          categorie: CATEGORIE_REGROUPEMENT_NUMERIQUE,
          label: this.$t('ajoutDevis.resNum'),
          action: () => { this.ajoutProduit(this.reseauNumerique); },
          order: 6,
        },
        {
          categorie: CATEGORIE_PRESSE,
          label: this.$t('ajoutDevis.presse'),
          action: () => { this.ajoutProduitPresse(); },
          order: 7,
        },
        {
          categorie: CATEGORIE_SPONSORING,
          label: this.$t('ajoutDevis.sponsoring'),
          action: () => { this.ajoutProduitSponsoring(); },
          order: 8,
        },
        {
          categorie: CATEGORIE_SALON,
          label: this.$t('ajoutDevis.salon'),
          action: () => { this.ajoutProduitSalon(); },
          order: 9,
        },
        {
          categorie: CATEGORIE_AUTRE,
          label: this.$t('ajoutDevis.autre'),
          action: () => { this.ajoutProduitAutre(); },
          order: 10,
        },
      ];

      if (!this.isCommandeFromDevis) {
        actions.push(
          {
            categorie: CATEGORIE_REGROUPEMENT,
            label: this.$t('ajoutDevis.reseauTempo'),
            action: () => { this.ajoutProduitReseauTempo(); },
            order: 2,
          },
        );
      }

      return actions.filter(action => this.categorieProduitByCode.includes(action.categorie));
    },
  },
  methods: {
    ...Commandes.mapMutations({
      setCommande: types.SET_COMMANDE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getallOpen() {
      return this.allOpen;
    },
    toggle() {
      this.allOpen = !this.allOpen;
      Object.keys(this.$refs.ligneVente.$refs).forEach(typeLignes => {
        this.$refs.ligneVente.$refs[typeLignes].forEach(ligne => {
          if (ligne.toggleDetail) ligne.toggleDetail(this.allOpen);
        });
      });
    },
    remiseNetFace() {
      this.calcul();
      this.$refs.ligneVente.updateTypeRemiseLocal();
      this.popUpRemiseNetFace = false;
    },
    getLignesCommandeToDisplay(isCommandeId) {
      if (!this.dcfIsCommandePartiellement) return this.dcf.lignesCommande;
      return this.dcf.lignesCommande.filter((ligne) => {
        return isCommandeId ? ligne.commandeId : !ligne.commandeId;
      });
    },
    changeEtatSouhaiteReseauTempo(newEtat) {
      this.dcf.lignesCommande
        .filter((ligneCommande) => {
          return ligneCommande.type === devisConf.REGROUPEMENT
          && ligneCommande.typeProduit === this.produitRegroupement && ligneCommande.selected;
        })
        .forEach((ligneReseauTempo) => {
          if (ligneReseauTempo.etatSouhaite === newEtat) { return; }
          ligneReseauTempo.etatSouhaite = newEtat;
          ligneReseauTempo.etatObtenu = AUCUN;
          ligneReseauTempo.etatProvisoire = AUCUN;
          ligneReseauTempo.rangOption = null;
          ligneReseauTempo.etatDeLaDemande = true;
          simulationEtatObtenu(ligneReseauTempo,
            this.dcf.societeId ? this.dcf.societeId : this.societeActiveId);
        });
      this.popUpChangeMultipleEtatOption = false;
    },
    selectAllLigneCommande() {
      this.selectAllLine = !this.selectAllLine;
      this.dcf.lignesCommande.forEach((ligne) => {
        if (!this.isCreditNote && ligne.commandeId) return;
        ligne.selected = this.selectAllLine;
      });
    },
    ajoutProduit(typeProduit) {
      this.setCommande(this.dcf);
      this.$router.push({
        name: 'c.bodac.commandes-planningNumeriqueAjout',
        params: { typeProduit: typeProduit, breadcrumb: this.breadcrumb },
      });
    },
    modificationLigneCommande(nouvelleLigneCommande, ordre) {
      modificationLigne(this.dcf, ordre, nouvelleLigneCommande[0]);
      this.ordreDernierAjoute = ordre;
      this.calcul();
      this.$emit('typeProduitChange');
    },
    ajoutProduitFace() {
      this.setCommande(this.dcf);
      this.$router.push({ name: 'rechercheProduitUnitaire', params: { breadcrumb: this.breadcrumb } });
    },
    ajoutProduitSalon() {
      this.setCommande(this.dcf);
      this.breadcrumb[2].isActive = false;
      this.breadcrumb.push({ title: this.$t('ajoutSalonDcf.title'), route: '', isActive: true });
      this.$router.push({ name: 'c.bodac.commandes-salon', params: { breadcrumb: this.breadcrumb } });
    },
    ajoutProduitSponsoring() {
      this.setCommande(this.dcf);
      this.breadcrumb[2].isActive = false;
      this.breadcrumb.push({ title: this.$t('ajoutSponsoringDcf.title'), route: '', isActive: true });
      this.$router.push({ name: 'c.bodac.commandes-sponsoring', params: { breadcrumb: this.breadcrumb } });
    },
    ajoutProduitAutre() {
      this.setCommande(this.dcf);
      this.breadcrumb[2].isActive = false;
      this.breadcrumb.push({ title: this.$t('ajoutAutreDcf.title'), route: '', isActive: true });
      this.$router.push({ name: 'c.bodac.commandes-autre', params: { breadcrumb: this.breadcrumb } });
    },
    ajoutProduitPresse() {
      this.setCommande(this.dcf);
      this.breadcrumb[2].isActive = false;
      this.breadcrumb.push({ title: this.$t('ajoutPresseDcf.title'), route: '', isActive: true });
      this.$router.push({ name: 'c.bodac.commandes-presse', params: { breadcrumb: this.breadcrumb } });
    },
    ajoutProduitReseauTempo() {
      this.setCommande(this.dcf);
      this.breadcrumb[2].isActive = false;
      this.breadcrumb.push({ title: this.$t('reseauTempo.title'), route: '', isActive: true });
      this.$router.push({ name: 'c.bodac.commandes-planningReseauTemporaire', params: { breadcrumb: this.breadcrumb } });
    },
    ajoutProduitReseauLc() {
      this.setCommande(this.dcf);
      this.breadcrumb[2].isActive = false;
      this.breadcrumb.push({ title: this.$t('ajoutReseauLc.title'), route: '', isActive: true });
      this.$router.push({ name: 'c.bodac.commandes-reseauLc', params: { breadcrumb: this.breadcrumb } });
    },
    ajoutProduitReseauMairie() {
      this.setCommande(this.dcf);
      this.breadcrumb[2].isActive = false;
      this.breadcrumb.push({ title: this.$t('addReseauMairieInDcf.title'), route: '', isActive: true });
      this.$router.push({ name: 'c.bodac.commandes-reseauMairie', params: { breadcrumb: this.breadcrumb } });
    },
    ajouterLigne(type) {
      this.dcf.lignesCommande.push(
        genererLigneCommande(maxOrderBaseGetter(this.dcf.lignesCommande) + 1),
      );
      const indexNouvelleValeur = this.dcf.lignesCommande.length - 1;
      if (type === this.typeArticle) {
        miseAJourArticle(this.dcf.lignesCommande[indexNouvelleValeur], this.getRemiseTvaDefaut);
        addReferenceEcheancierToLigneCommande(
          this.dcf.lignesCommande[indexNouvelleValeur], this.dcf,
        );
      } else if (type === this.typeSousTotal) {
        miseAJourSousTotal(
          this.dcf.lignesCommande[indexNouvelleValeur],
          this.$i18n,
        );
      } else if (type === this.typeCommentaire) {
        miseAJourCommentaire(
          this.dcf.lignesCommande[indexNouvelleValeur],
        );
      }
      if (this.isCreditNote) {
        this.dcf.lignesCommande.forEach(ligne => {
          if (ligne.quantite > 0) ligne.quantite *= -1;
        });
      }
      this.calcul();
    },
    ajouterLigneRemise() {
      this.dcf.lignesCommande.push(
        genererLigneCommande(maxOrderBaseGetter(this.dcf.lignesCommande) + 1),
      );
      const indexNouvelleValeur = this.dcf.lignesCommande.length - 1;
      miseAJourLigneRemise(
        this.dcf.lignesCommande[indexNouvelleValeur],
        this.$i18n,
      );
    },
    majRemiseGrouped(ligneWithNewRemise, typesProduit) {
      const produits = [...new Set(typesProduit.map((el) => el.produitId))];
      calculRemiseMultiProduitWithSoult(
        ligneWithNewRemise,
        this.selectLinesGetter
          .filter((ligne) => {
            // On retire les lignes de regroupement et les lignes a 0;
            return ligne.totalHt > 0 && ligne.produitId && ligne.type !== devisConf.REGROUPEMENT;
          })
          .filter((ligne) => {
            if (produits.length === 1 && produits[0] === null
              && (ligne.typeProduit === produitConf.CATEGORIE_DIVERS
                || ligne.typeProduit === produitConf.CATEGORIE_LOCATION
                || ligne.typeProduit === produitConf.CATEGORIE_ENCART
                || ligne.typeProduit === produitConf.CATEGORIE_PRESTATION)) return true;
            return produits.includes(ligne.produitId);
          })
          .sort((a, b) => { return a.totalHt + b.totalHt; }),
        this.dcf,
      );

      this.popUplignesRemise = false;
      this.calcul();
      this.$refs.ligneVente.updateTypeRemiseLocal();
    },
    calcul() {
      this.$emit('calcul');
    },
    dissocierPersonnalise(ordre) {
      suppressionRegroupementPersonnalise(ordre, this.dcf.lignesCommande);
      this.changeOrder();
    },
    affInformationRegroupement() {
      this.messagesPopup = [];
      if (validationRegroupementInformation(this.dcf.lignesCommande,
        this.messagesPopup, this.getSelectedLigne)) {
        this.headerError = this.$i18n.t('ligneRegroupementPersonnalisee.popup.unableToViewInformation');
        this.errorPopUp = true;
        this.isErrorPopUpInformationRegroupement = true;
      } else {
        this.popUpInformationRegroupement = true;
      }
    },
    checkLigneWithFacturationFaire(lignes) {
      let ligneAlreadyFacture = false;
      lignes.forEach((ligne) => {
        if (!this.dcf.echeanciers) return;
        const echeancier = this.dcf.echeanciers.find((ech) => {
          return ech.referenceEcheancier === ligne.referenceEcheancier;
        });
        if (echeancier && echeancier.echeancierLignes.some((echLigne) => {
          return echLigne.facturationFaite;
        })) ligneAlreadyFacture = true;
        if (!ligne.lignesCommande) return;
        ligne.lignesCommande.forEach((ligneEnfant) => {
          const echeancier = this.dcf.echeanciers.find((ech) => {
            return ech.referenceEcheancier === ligneEnfant.referenceEcheancier;
          });
          if (echeancier && echeancier.echeancierLignes.some((echLigne) => {
            return echLigne.facturationFaite;
          })) ligneAlreadyFacture = true;
        });
      });
      return ligneAlreadyFacture;
    },
    errorsManager(messages) {
      this.$emit('messagesErrors', messages);
      this.headerError = this.$i18n.t('editionCommande.messages.errors.ligneCommandeDeleteError');
      this.errorPopUp = true;
    },
    isLigneRegroupementReseauInDevisWithValidationModifBlocage(ligne) {
      return (estDemandeManuelle() && this.dcf.id
        && [devisConf.TYPE_DEVIS, devisConf.TYPE_COMMANDE].includes(this.dcf.type)
        && ligne.typeProduit === produitConf.CATEGORIE_REGROUPEMENT
        && ligne.type === devisConf.REGROUPEMENT
        && [BLOQUE, BLOQUE_COMMANDE].includes(ligne.etatObtenu));
    },
    checkLignesWithValidationModifBlocage(selectedLines) {
      return selectedLines.some((ligne) => {
        return this.isLigneRegroupementReseauInDevisWithValidationModifBlocage(ligne);
      });
    },
    async checkValidationLigneCommandeForDelete(ids) {
      if (!ids?.filter(id => !!id).length) return;
      try {
        const ligneCommandeIds = ids.filter(id => !!id);
        await checkValidationLigneCommandeForDeleteAsync({ ligneCommandeIds });
      } catch (e) {
        const messages = [];
        validationLigneCommandeDemandeLogistique(e.response, messages);
        this.errorsManager(messages);
        throw e;
      }
    },
    async suppressionMulti() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const selectedLines = this.dcf.lignesCommande.filter(l => l.selected);
        await this.checkValidationLigneCommandeForDelete(selectedLines.map(l => l.id));
        if (this.interdireModificationBlocageCLGActive
          && this.checkLignesWithValidationModifBlocage(selectedLines)) {
          if (this.dcf.type === devisConf.TYPE_DEVIS) {
            this.headerError = this.$i18n.t('validationDevis.suppProduitRegroupementInDevisWithValidationModifBlocage');
          } else this.headerError = this.$i18n.t('validationCommande.suppProduitRegroupementInDevisWithValidationModifBlocage');
          this.errorPopUp = true;
          return;
        }
        if (this.checkLigneWithFacturationFaire(selectedLines)) {
          this.headerError = this.$i18n.t('editionCommande.messages.errors.deleteLigneWithEcheanceFacture');
          this.errorPopUp = true;
          return;
        }
        if (checkIfLignesCanBeDeletedWithBesoin(selectedLines, this.dcf)) {
          this.headerError = this.$i18n.t('editionCommande.messages.errors.deleteLigneWithBesoin');
          this.errorPopUp = true;
          return;
        }
        selectedLines.forEach((ligne) => {
          if (ligne.referencePersonnalise && !ligne.produitId) {
            suppressionRegroupementPersonnalise(ligne.ordre, this.dcf.lignesCommande);
          } else if (!ligne.referencePersonnalise) {
            this.dcf.lignesCommande.splice(this.dcf.lignesCommande.indexOf(ligne), 1);
          }
        });
        deleteLignesEcheanciersInutiles(this.dcf);
        this.calcul();
      } finally {
        loadingComponent.close();
      }
    },
    makeDuplication(qte = 1) {
      this.dcf.lignesCommande.sort((a, b) => a.ordre - b.ordre);
      const lignes = [];
      let ordre = 0;
      this.dcf.lignesCommande.forEach(ligne => {
        if (ligne.selected) {
          ordre += 100;
          ligne.ordre = ordre;
          for (let i = 0; i < qte; i += 1) {
            const clone = cloneDeep(ligne);
            delete clone.id;
            delete clone.referenceRegroupement;
            delete clone.referenceEcheancier;
            clone.selected = false;
            clone.isDuplicated = true;
            if (clone.lignesCommande) {
              clone.lignesCommande.forEach((sousLigne) => {
                delete sousLigne.id;
                delete sousLigne.referenceEcheancier;
                sousLigne.lignesRemise.forEach((ligneRemise) => {
                  delete ligneRemise.id;
                });
              });
            }
            ordre += 100;
            clone.ordre = ordre;
            initialisationOptionBlocage(clone);
            addReferenceEcheancierToLigneCommande(clone, this.dcf);
            lignes.push(clone);
          }
        } else {
          ordre += 100;
          ligne.ordre = ordre;
        }
      });
      this.dcf.lignesCommande.push(...lignes);
      this.dcf.lignesCommande.sort((a, b) => a.ordre - b.ordre);
      this.calcul();
    },
    checkOpenPopUpRemiseNetFace() {
      const selectedLines = this.dcf.lignesCommande.filter(l => l.selected);
      if (!selectedLines.every((selectedLines => {
        return selectedLines.typeProduit === produitConf.CATEGORIE_REGROUPEMENT;
      }))) {
        this.headerError = this.$i18n.t('dcf.messages.errors.remiseNetFace');
        this.errorPopUp = true;
      } else this.popUpRemiseNetFace = true;
    },
    handleAction(action) {
      switch (action) {
        case devisConf.ACTION_GROUPER_PERSONNALISE:
          this.grouperLignes();
          break;
        case devisConf.ACTION_GROUPER_MAJ_PU:
          this.affichagePopUpMajTarif = true;
          break;
        case devisConf.ACTION_GROUPER_MAJ_TVA:
          this.affichagePopUpMajTva = true;
          break;
        case devisConf.ACTION_INFORMATION_GROUPER_PERSONNALISE:
          this.affInformationRegroupement();
          break;
        case ACTION_MASS_DELETE:
          this.suppressionMulti();
          break;
        case devisConf.ACTION_GROUPER_MAJ_ETAT_SOUHAITE:
          this.popUpChangeMultipleEtatOption = true;
          break;
        case devisConf.ACTION_GROUPER_MAJ_REMISE:
          this.popUplignesRemise = true;
          break;
        case devisConf.ACTION_REMISE_PRIX_NET_FACE:
          this.checkOpenPopUpRemiseNetFace();
          break;
        case devisConf.ACTION_DUPLICATION:
          this.openPopUpForDuplicate();
          break;
        case devisConf.ACTION_MODIFIER_DATES:
          this.popUpModifierDates = true;
          break;
        default:
          break;
      }
    },
    openPopUpForDuplicate() {
      const hasRegroupementPersonnalise = this.dcf.lignesCommande.filter(l => l.selected).some(
        ligne => ligne.type === devisConf.PERSONNALISE || ligne.referencePersonnalise);
      if (hasRegroupementPersonnalise) {
        this.messagesPopup = [];
        this.headerError = this.$i18n.t('dcf.messages.errors.duplicatePossibility');
        this.errorPopUp = true;
      } else {
        this.popUpDuplicationLigne = true;
      }
    },
    fusionRegroupementPerso(lignes, devisCommande) {
      let referencesEcheancier = [];
      lignes.forEach((ligne) => {
        if (ligne.referenceEcheancier) referencesEcheancier.push(ligne.referenceEcheancier);
        if (ligne.lignesCommande) {
          referencesEcheancier = referencesEcheancier.concat(
            ligne.lignesCommande.map((ligneEnfant) => { return ligneEnfant.referenceEcheancier; }),
          );
        }
      });
      fusionEcheancier(referencesEcheancier, devisCommande);
    },
    grouperLignes() {
      const selectedLines = this.dcf.lignesCommande.filter(l => l.selected);
      const messages = [];
      if (validationRegroupementPersonnalise(
        selectedLines, this.dcf, messages,
      )) {
        creationRegroupementPersonnalise(
          selectedLines, this.dcf.lignesCommande, this.$i18n,
        );
        if (this.dcf.type === devisConf.TYPE_COMMANDE || this.dcf.type === devisConf.TYPE_DEVIS) {
          this.fusionRegroupementPerso(selectedLines, this.dcf);
        }
        // J'aimerais le mettre dans la méthode mais ça complique tout
        // j'hésite
        this.changeOrder();

        // déselection de toutes les lignes
        this.dcf.lignesCommande.forEach(l => {
          l.selected = false;
        });
      } else {
        this.messagesPopup = messages;
        this.headerError = this.$i18n.t('ligneRegroupementPersonnalisee.popup.unableToCreate');
        this.errorPopUp = true;
      }
    },
    changeOrder() {
      // On réordonne les éléments liées à un réseau personnalisé
      // pour les mettre en dessous de la ligne de réseau personnalisé
      reordonnancementRegroupementPersonnalise(this.dcf.lignesCommande);
      this.dcf.lignesCommande.forEach((ligneCommande) => {
        ajoutOrdre(ligneCommande, this.dcf.lignesCommande.indexOf(ligneCommande));
      });
      this.calcul();
    },
    updatePrixUnitaire(pourcentageOrNewPu, typeMaj) {
      const listeLigneAMettreAJour = selectLinesFormRegroupementPersonalise(
        this.dcf.lignesCommande,
      );
      miseAJourPrixUnitaire(listeLigneAMettreAJour, pourcentageOrNewPu, typeMaj);
      this.calcul();
    },
    updateTva(tva) {
      const listeLigneAMettreAJour = selectLinesFormRegroupementPersonalise(
        this.dcf.lignesCommande,
      );
      miseAJourTva(listeLigneAMettreAJour, tva);
      this.calcul();
    },
    gestionTriLignes(params) {
      this.dcf.lignesCommande = trierListe(this.dcf.lignesCommande, params.property, params.sens);
      this.changeOrder();
    },
    async updateDate(date) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const listeLigneAMettreAJour = this.dcf.lignesCommande
          .filter((ligne) => ligne.selected)
          .filter((ligne) => this.canUpdateDate(ligne));
        miseAJourDate(listeLigneAMettreAJour, date);
        updateDatesAllEcheancierAuto(this.dcf);
        const promises = listeLigneAMettreAJour.map((ligne) => this.updateAffectation(ligne));
        await Promise.all(promises);
        listeLigneAMettreAJour.map((ligne) => updateQuantiteDispo(ligne));
        this.calcul();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        throw e;
      }
    },
    async updateAffectation(ligne) {
      let affectationList;
      if (ligne.typeProduit === produitConf.CATEGORIE_UNITAIRE) {
        affectationList = await getAffectionOfProductFace([ligne]);
      } else if (ligne.typeProduit === produitConf.CATEGORIE_REGROUPEMENT_LC) {
        affectationList = await getAffectionOfProductReseauLc([ligne]);
      } else if (ligne.typeProduit === produitConf.CATEGORIE_ECRAN_NUMERIQUE) {
        affectationList = await getAffectionOfProductEcranNumerique([ligne]);
      } else if (ligne.typeProduit === produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE) {
        affectationList = await getAffectionOfProductReseauNumerique([ligne]);
      } else {
        return;
      }
      updateAffection(
        ligne,
        this.dcf,
        affectationList[ligne.produitId],
      );
    },
    canUpdateDate(ligne) {
      if (!ligne.typeProduit) return false;
      return ligne.typeProduit.toLowerCase() === CATEGORIE_UNITAIRE.toLowerCase()
          || ligne.typeProduit.toLowerCase() === CATEGORIE_REGROUPEMENT_LC.toLowerCase()
          || ligne.typeProduit.toLowerCase() === CATEGORIE_ECRAN_NUMERIQUE.toLowerCase()
          || ligne.typeProduit.toLowerCase() === CATEGORIE_REGROUPEMENT_NUMERIQUE.toLowerCase();
    },
  },
  provide() {
    return {
      allOpen: this.getallOpen,
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.dcf.type === devisConf.TYPE_DEVIS) {
        this.actions.splice(this.actions.length - 1, 0, {
          action: devisConf.ACTION_GROUPER_MAJ_ETAT_SOUHAITE,
          translation: 'ajoutDevis.actions.modifierEtatSouhaite',
        });
      }
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key,
        PARAMETRES_INTERNE_KEYS.activationYield.key,
        PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key,
        PARAMETRES_INTERNE_KEYS.interdireModificationBlocageCLG.key,
      ]);
      await this.loadParametres([PARAMETRES_KEYS.regimeTva]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
